import * as AUTH_ACTION from 'common/constant/actions/auth'
import { handleActions } from 'redux-actions'

const initialState = {
  generalDidError: false,
  isAuthenticated: false,
  loginCheckComplete: false,
  loading: false
}

export default handleActions(
  {
    [AUTH_ACTION.UPDATE_AUTH_STATE]: (state, action) => ({
      ...state,
      ...action.payload
    }),
    [AUTH_ACTION.UPDATE_GENERAL_DID_ERROR]: (state, action) => ({
      ...state,
      generalDidError: action.payload
    })

  },
  initialState
)
